<script>
    import { onMount } from 'svelte';
    import { copyToClipboard } from '../methods/copyToClipboard.js';

    export let mtappVars;

    let contentFields = null;
    let contentFieldsGroups = [];
    let destinationGroup = '';
    let movingFieldsIds = [];
    let optionChangeFormat = false;
    let optionMethod = 'after';
    let optionSelector = '';
    let optionType = 'card';
    let settingJson = '';
    let visible = false;

    /**
     * 新規グループを追加
     */
    function addGroup() {
        contentFieldsGroups.push({
            label: `グループ${contentFieldsGroups.length + 1}`,
            key: `group-${contentFieldsGroups.length + 1}`,
            fields: [] // { id: Number, column: String }
        });
        contentFieldsGroups = contentFieldsGroups;
    }

    /**
     * フィールドをグループに入れる
     */
    function moveFields() {
        contentFields.forEach((field) => {
            if (movingFieldsIds.includes(field.id)) {
                field.group = destinationGroup;
            }
        });
        contentFields = contentFields;
        movingFieldsIds = [];
    }

    /**
     * グループからフィールドを削除
     * @param fieldIdx
     */
    function removeField(fieldIdx) {
        contentFields[fieldIdx].group = '';
        contentFields[fieldIdx].isActive = false;
        contentFields = contentFields;
    }

    /**
     * 書き出したJSONを空にする
     */
    function resetJson() {
        settingJson = '';
    }

    /**
     * 設定ブロックの表示・非表示の切り替え
     */
    function toggleVisible() {
        visible = !visible;
    }

    /**
     * JSON を出力
     */
    function printSetting() {
        contentFieldsGroups.forEach((group) => {
            const groupKey = group.key;
            group.fields = [];
            contentFields.forEach((field) => {
                if (field.group === groupKey) {
                    group.fields.push({
                        label: field.options.label,
                        column: field.column
                    });
                }
            });
        });
        const settings = {
            group: [...contentFieldsGroups],
            selector: optionSelector,
            type: optionType,
            method: optionMethod,
            changeFormat: optionChangeFormat
        };
        settingJson = `mtapp.columnGroup(${JSON.stringify(settings, null, 4)});`;
    }

    /**
     * 出力した JSON から復元
     */
    function restoreSetting() {
        let settings = settingJson
            .trim()
            .replace(/^mtapp.*?\.columnGroup\(/, '')
            .replace(/\);$/, '')
            .trim();
        try {
            settings = JSON.parse(settings);
            contentFieldsGroups = settings.group;
            contentFieldsGroups.forEach((group) => {
                const groupKey = group.key;
                group.fields.forEach((field) => {
                    contentFields.forEach((contentField) => {
                        if (contentField.options.label === field.label) {
                            contentField.group = groupKey;
                            contentField.column = field.column;
                        }
                    });
                });
            });
            contentFields = contentFields;
            optionSelector = settings.selector;
            optionMethod = settings.method;
            optionType = settings.type;
            optionChangeFormat = settings.changeFormat;
        } catch (error) {
            console.error('JSON parsing failed:', error);
            return;
        }
    }

    onMount(() => {
        if (typeof mtappVars.content_type !== 'object' || typeof mtappVars.content_type.fields !== 'object') {
            return;
        }
        contentFields = mtappVars.content_type.fields.map((field) => {
            field.id = parseInt(field.id);
            field.order = parseInt(field.order);
            field.group = '';
            field.column = 'col-lg-6';
            field.isActive = '';
            return field;
        });
    });
</script>

<div id="mtapp-column-group-setting" class="mt-5">
    <button class="btn btn-default btn-block" on:click={toggleVisible}>{mtappVars.translate['Set Field Group']}</button>

    <div class="card mt-5" class:d-none={!visible}>
        <div class="card-header">{mtappVars.translate['Set Field Group']}</div>
        <div class="card-body">
            <div class="row mb-4">
                <div class="col-6">
                    {#each contentFieldsGroups as group}
                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="mb-3">
                                    <label for="{group.key}-label" class="form-label">{mtappVars.translate['Group Name']}</label>
                                    <input type="text" class="form-control" id="{group.key}-label" bind:value={group.label} />
                                </div>
                                <div class="mb-3">
                                    <label for="{group.key}-key" class="form-label">{mtappVars.translate['Group ID']}</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="{group.key}-key"
                                        bind:value={group.key}
                                        disabled={destinationGroup === group.key} />
                                </div>
                                <ul class="list-group">
                                    {#each contentFields as field, fieldIdx}
                                        {#if field.group === group.key}
                                            <div class="row align-items-center py-2">
                                                <div class="col-6">
                                                    {field.options.label}
                                                </div>
                                                <div class="col-4 mr-0 pr-0">
                                                    <input type="text" class="form-control" bind:value={field.column} />
                                                </div>
                                                <div class="col-2 mx-0 px-0 text-center">
                                                    <a
                                                        href="#remove"
                                                        class="d-inline-block"
                                                        on:click|preventDefault={() => removeField(fieldIdx)}
                                                        aria-label="Remove">
                                                        <svg role="img" class="mt-icon--secondary">
                                                            <use xlink:href="{mtappVars.static_path}images/sprite.svg#ic_trash"></use>
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                        {/if}
                                    {/each}
                                </ul>
                            </div>
                        </div>
                    {/each}
                    <p class="form-inline">
                        <button class="btn btn-primary" type="button" on:click={addGroup}>{mtappVars.translate['Add Group']}</button>
                    </p>
                </div>
                <div class="col-6">
                    <ul class="list-group mb-5">
                        {#if contentFields}
                            {#each contentFields as field, fieldIdx}
                                {#if !field.group}
                                    <li class="list-group-item mb-0">
                                        <input
                                            class="form-check-input me-1"
                                            type="checkbox"
                                            bind:group={movingFieldsIds}
                                            value={field.id}
                                            id="movingFieldsId-{fieldIdx}-{field.id}" />
                                        <label class="form-check-label" for="movingFieldsId-{fieldIdx}-{field.id}"
                                            >{field.options.label}</label>
                                    </li>
                                {/if}
                            {/each}
                        {/if}
                    </ul>
                    <div class="my-4">
                        <label for="mtapp-field-destination" class="form-label">{mtappVars.translate['Destination Group']}</label>
                        <select id="mtapp-field-destination" class="form-select" bind:value={destinationGroup}>
                            <option value=""></option>
                            {#each contentFieldsGroups as group}
                                <option value={group.key}>{group.label}</option>
                            {/each}
                        </select>
                    </div>
                    <button class="btn btn-primary" on:click={moveFields} disabled={destinationGroup === ''}
                        >{mtappVars.translate['Add Selected Fields to Group']}</button>
                </div>
            </div>
            <div class="mb-3">
                <label for="optionSelector" class="form-label">{mtappVars.translate['Selector for the Node at Insertion Point']}</label>
                <input class="form-control" type="text" id="optionSelector" bind:value={optionSelector} on:change={resetJson} />
                <div class="form-text">{mtappVars.translate['Selector for the Node to Start Inserting the Group']}</div>
            </div>
            <div class="mb-3">
                <label for="optionMethod" class="form-label">{mtappVars.translate['Insertion Method']}</label>
                <select id="optionMethod" class="form-select" bind:value={optionMethod} on:change={resetJson}>
                    <option value="after">After</option>
                    <option value="before">Before</option>
                    <option value="prepend">Prepend</option>
                    <option value="append">Append</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="optionType" class="form-label">{mtappVars.translate['Type of Group']}</label>
                <select id="optionType" class="form-select" bind:value={optionType} on:change={resetJson}>
                    <option value="card">Card</option>
                    <option value="collapse">Collapse</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="optionChangeFormat" class="form-label">{mtappVars.translate['Change Rich Editor Format']}</label>
                <select id="optionChangeFormat" class="form-select" bind:value={optionChangeFormat} on:change={resetJson}>
                    <option value={true}>{mtappVars.translate['Allow']}</option>
                    <option value={false}>{mtappVars.translate['Do Not Allow']}</option>
                </select>
            </div>
            <div class="mb-3">
                <p>
                    <button class="btn btn-primary" on:click={printSetting} disabled={optionSelector === ''}
                        >{mtappVars.translate['Export Settings']}</button>
                    <button class="btn btn-secondary ml-2" on:click={restoreSetting} disabled={settingJson === ''}
                        >{mtappVars.translate['Import Settings']}</button>
                </p>
                <textarea id="mtapp-column-group-setting-json" class="form-control font-monospace" rows="10" bind:value={settingJson}
                ></textarea>
            </div>
            {#if optionSelector !== '' && settingJson !== ''}
                <button
                    type="button"
                    class="btn btn-primary"
                    data-mtapp-copy-target-id="mtapp-column-group-setting-json"
                    on:click={(event) => {
                        if (event.target instanceof HTMLElement) {
                            copyToClipboard(event.target);
                        }
                    }}>{mtappVars.translate['Copy Settings to Clipboard']}</button>
            {/if}
        </div>
    </div>
</div>
